import React from 'react'
import { useNavigate } from 'react-router-dom'
import HeadingText from '../ActionCommonComponent/HeadingText'
import InfoBox from '../../components/InfoBox'
import PasswordField from '../../components/PasswordField'
import SignatureBox from '../../components/SignatureBox'

const ConfirmView = ({data}) => {
    const navigate = useNavigate();
    const { version_id, action, version_content,comment} = data 
    const { savedBy, is_password_included, is_signature_included,password_bullets } = version_content.confirmationPopupInfo
  return <>
    <HeadingText heading="Associated Version" text={version_id}/>
    <HeadingText heading="Activity" text={action}/>

    <HeadingText heading={"Details (Read Only)"}>
        <InfoBox
            heading={"Save Application Setup"}
            buttons={[
                {
                 text:"Preview",
                 onClick:()=>navigate(`/audit-trail/appsetup-preview/${data.audit_trail_id || data._id}`),
                 disabled:false   
                }
            ]}
        >
        <div style={{ marginBottom: "20px" }}>
            <HeadingText
              heading="Saved By:"
              text={savedBy}
              normal={true}
            />
        </div>

        <label>Application Setup Save Comments</label>
          <textarea
            class="input-textarea"
            disabled
            style={{ marginBottom: "20px" }}
            value={comment}
            rows={6}
          ></textarea>

        {is_password_included && <PasswordField  password_bullets={password_bullets}/>}
        {is_signature_included && <>
        <label style={{ marginTop: "20px" }}>Sign Here<span style={{ color: "#0D6EFD", marginLeft: "-1px" }}>*</span></label>
        <SignatureBox />
        </>}
        </InfoBox>
    </HeadingText>
  </>
}

export default ConfirmView